export const bgGridDotColor = '#F8FAFA'
export const greyGridDotColor = '#DEE4E4'
export const tealGridDotColor = '#0B8381'
